var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEmptyData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10753"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8437",
    transform: "translate(0 -.001)",
    style: {
      fill: "none"
    },
    d: "M0 0h120v120H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10755"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7211",
    d: "M470.243 707.7a2.093 2.093 0 0 0-.089-1.079c-.145-.461-.9-.665-1.133-.148-.022.053-.049.1-.076.155-.113.137-.193.289-.317.44-.012.015-.172.177-.156.164-.03.021-.061.039-.092.059a3.986 3.986 0 0 0-.419-.027h-.116l-.37-.05a1.815 1.815 0 0 0-.552.093 1.623 1.623 0 0 0 0 3.1 1.806 1.806 0 0 0 .5.074 15.028 15.028 0 0 0 1.6-2 1.788 1.788 0 0 1 1.22-.781z",
    transform: "translate(-446.034 -646.961)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7212",
    d: "M465.9 713.685a.89.89 0 0 0 .9 1.535 22.749 22.749 0 0 0 4.314-2.526 1.681 1.681 0 0 0 .333-2.583 1.571 1.571 0 0 0-1.357-.452 1.788 1.788 0 0 0-1.227.785 15.022 15.022 0 0 1-1.6 2 11.77 11.77 0 0 1-1.363 1.241z",
    transform: "translate(-445.874 -648.922)",
    style: {
      fill: "#e9eced"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7216",
    d: "m464.541 708.125.709 1.093a.653.653 0 0 0 .468.293.62.62 0 0 0 .08 0 .653.653 0 0 0 .445-.174 30.673 30.673 0 0 1 4.079-3.055.653.653 0 0 0 .183-.912 38.149 38.149 0 0 1-1.9-3.153.654.654 0 0 0-1.017-.171 25.9 25.9 0 0 1-3.377 2.483q-.433.284-.865.571a.655.655 0 0 0-.184.9q.691 1.062 1.379 2.125zm.389-2.5a33.369 33.369 0 0 0 2.919-2.071c.395.7.8 1.366 1.208 2a32.186 32.186 0 0 0-3.124 2.312l-.3-.454-1.024-1.578z",
    transform: "translate(-444.501 -644.543)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10770"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10900",
    d: "M49.962 42.968 21.115 97.67H78.13l3.437-44.186-16.081-3.815",
    transform: "translate(-4.935 5.833)",
    style: {
      fillRule: "evenodd",
      fill: "#e9eced"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10750"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10901",
    d: "M4.695 0S2.982 8.759 0 10.14c.009.119 8.22 2.714 8.22 2.714s2.8-2.946 4.253-11C12.611 1.786 4.695 0 4.695 0z",
    transform: "translate(60.188 61.961)",
    style: {
      strokeWidth: "1.4px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10902",
    d: "m8.04 13.2-.984-3.3s3.653.889 4.362-1.134",
    transform: "translate(59.488 61.09)",
    style: {
      strokeWidth: "1.6px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10751"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10903",
    d: "M10.51 0s1.826 10.919 5.742 12.615c-.019.151-11.14 3.461-11.14 3.461S1.514 12.426 0 2.39C-.171 2.3 10.51 0 10.51 0z",
    transform: "translate(36.231 69.524)",
    style: {
      strokeWidth: "1.6px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10904",
    d: "m6.01 17.911.98-3.091s-3.459.78-4.09-1.142",
    transform: "translate(35.772 67.353)",
    style: {
      strokeWidth: "1.6px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10905",
    d: "M0 13.51C1.092 10.854 4.522-2.671 21.3.47c15.27 5.112 12.185 20.788 12.185 20.788S11.119 22.128 0 13.51z",
    transform: "rotate(7 -157.681 421.864)",
    style: {
      strokeWidth: "1.8px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10906",
    d: "M12.886.008S2.756-.381.367 4.219s6.8 13.921 30 17.864S59.5 19.7 59.948 17.755s-.648-7.591-9.43-10.213",
    transform: "rotate(7 -232.214 299.87)",
    style: {
      strokeWidth: "1.8px",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10907",
    d: "M0 0a10.726 10.726 0 0 1 4.653 8.946",
    transform: "rotate(7 -239.905 625.705)",
    style: {
      strokeWidth: 2,
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10909",
    d: "M58.741 41.017a2.724 2.724 0 0 1 3.069 2.348 2.755 2.755 0 0 1-2.31 3.12 2.722 2.722 0 0 1-3.068-2.351 2.752 2.752 0 0 1 2.311-3.117",
    transform: "translate(-1.352 4.985)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10911",
    d: "M87.073 132.026c-17.32.062-80.184 0-80.184 0",
    transform: "translate(5.288 -28.021)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10912",
    d: "M2.708.26a1.049 1.049 0 0 0-.982-.221A2.394 2.394 0 0 0 .054 2.894a1.213 1.213 0 0 0 1.485.843 2.338 2.338 0 0 0 1.652-1.813 1.634 1.634 0 0 0-.072-.755v-.051l.04-.115A.587.587 0 0 0 2.708.26z",
    transform: "rotate(7 -369.627 682.979)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10913",
    d: "M3.093.26A1.326 1.326 0 0 0 1.971.039 2.382 2.382 0 0 0 .062 2.894a1.419 1.419 0 0 0 1.7.843 2.483 2.483 0 0 0 1.883-1.813 1.442 1.442 0 0 0-.082-.755v-.051l.046-.115C3.757.659 3.452.347 3.093.26z",
    transform: "rotate(76 1.696 63.277)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10914",
    d: "M2.8.209A1.321 1.321 0 0 0 1.784.031a1.932 1.932 0 0 0-1.728 2.3A1.328 1.328 0 0 0 1.591 3 2.145 2.145 0 0 0 3.3 1.546 1.04 1.04 0 0 0 3.225.94V.899c.014-.031.027-.062.042-.092C3.4.529 3.125.279 2.8.209z",
    transform: "rotate(76 -1.447 49.893)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10910",
    d: "M1.871.022A2.179 2.179 0 0 1 4.327 1.9a2.2 2.2 0 0 1-1.85 2.5A2.179 2.179 0 0 1 .021 2.516a2.205 2.205 0 0 1 1.85-2.5zm19.984 1.605a2.179 2.179 0 0 1 2.455 1.881A2.2 2.2 0 0 1 22.46 6 2.178 2.178 0 0 1 20 4.121a2.206 2.206 0 0 1 1.85-2.5z",
    transform: "rotate(7 -349.935 510.837)",
    style: {
      strokeWidth: "1.6px",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10908",
    d: "M1.872.022A2.18 2.18 0 0 1 4.327 1.9a2.2 2.2 0 0 1-1.85 2.5A2.181 2.181 0 0 1 .021 2.517 2.2 2.2 0 0 1 1.872.022z",
    transform: "rotate(7 -296.903 381.77)",
    style: {
      strokeWidth: "1.6px",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10757"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10123",
    d: "M6.592 8.147A2.6 2.6 0 0 0 4.953 7.2c-1-.28-1.989-.577-2.986-.858-.72-.2-1.34-.313-1.818.364-.46.651.239 1.226.861 1.127a7.29 7.29 0 0 1 1.359.647q.782.351 1.561.709c.031.015.107.058.195.106a17.886 17.886 0 0 0-.54 1.976 1.331 1.331 0 0 0 .453 1.306q-.257.46-.488.934a.523.523 0 0 0 .9.528c.331-.432.686-.9 1.076-1.329a1.268 1.268 0 0 0 .455-.471 3.731 3.731 0 0 1 2.766-1.242 17.029 17.029 0 0 0 4.728-.355 10.032 10.032 0 0 0 6.543-4.556 1.433 1.433 0 0 0-.106-1.694 2.51 2.51 0 0 0 .151-2.263 1.312 1.312 0 0 0-.8-.758 4.585 4.585 0 0 0-.5-1 .764.764 0 0 0-1.39.586 8.684 8.684 0 0 1 .174 1.932 3.364 3.364 0 0 1-1.659 1.551c-1 .532-2.039 1-3.071 1.466a45.647 45.647 0 0 1-6.225 2.241z",
    transform: "rotate(14.98 -44.09 349.183)",
    style: {
      fill: "#e9eced"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10575",
    d: "M12.3.093c-.456-.019-.912-.037-1.368-.066A12.889 12.889 0 0 0 10.1 0a11.626 11.626 0 0 0-7.348 2.424A6.772 6.772 0 0 0 0 7.4c0 2.268 1.4 5.318 5.3 6.616q.032.538.068 1.078c.065 1.015.132 2.065.164 3.082a.507.507 0 0 0 .892.313A28.543 28.543 0 0 0 9.2 14.658c.208.007.42.01.632.01 3.129 0 13.338-.532 13.338-7.37 0-3.818-3.807-6.25-7.344-6.892A25.279 25.279 0 0 0 12.3.093zM22.157 7.3c0 5.9-9.433 6.356-12.324 6.356-.3 0-.6-.007-.889-.022a.51.51 0 0 0-.463.251 26.02 26.02 0 0 1-2 2.926c-.032-.6-.07-1.2-.107-1.782-.03-.474-.061-.948-.088-1.421a.507.507 0 0 0-.362-.457c-4.673-1.382-4.91-5.034-4.91-5.751 0-2.61 3.234-6.385 9.082-6.385.257 0 .516.008.767.024.464.029.928.049 1.392.068a24.5 24.5 0 0 1 3.39.3c3.236.584 6.512 2.798 6.512 5.893z",
    style: {
      strokeWidth: ".5px",
      stroke: "#525d7d",
      fill: "#525d7d"
    },
    transform: "rotate(14.98 -25.782 341.632)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10576",
    d: "M2.008 0a.911.911 0 0 0-.292.05.531.531 0 0 0-.329.32.507.507 0 0 0-.795.118.807.807 0 0 0-.387.379A1.712 1.712 0 0 0 0 1.638a1.394 1.394 0 0 0 1.43 1.385A1.685 1.685 0 0 0 3.073 1.3c0-.4-.402-1.3-1.065-1.3zM1.43 2.009a.382.382 0 0 1-.416-.372.672.672 0 0 1 .067-.253.656.656 0 0 0 .441-.472.479.479 0 0 0 .4.122.854.854 0 0 1 .134.268.681.681 0 0 1-.626.707z",
    transform: "rotate(14.98 -53.031 357.9)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10577",
    d: "M1.652.041A.5.5 0 0 0 1.391 0a.475.475 0 0 0-.062 0A1.509 1.509 0 0 0 0 1.477a1.62 1.62 0 0 0 1.638 1.5 1.452 1.452 0 0 0 1.476-1.29C3.113.935 2.326.33 1.652.041zm-.014 1.926c-.3 0-.624-.251-.624-.489 0-.189.221-.463.315-.463.479.221.771.54.771.676a.567.567 0 0 1-.462.276z",
    transform: "rotate(14.98 -54.256 378.65)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10578",
    d: "M1.063 2.688a1.729 1.729 0 0 0 .285-.029.781.781 0 0 1 .12-.015 1.4 1.4 0 0 0 1.157-1.322A1.391 1.391 0 0 0 1.584.015a.505.505 0 0 0-.347.037.5.5 0 0 0-.324.018A1.443 1.443 0 0 0 0 1.415a1.191 1.191 0 0 0 1.063 1.273zm.227-1.677L1.326 1a.394.394 0 0 1 .285.322.645.645 0 0 1-.2.314 1.949 1.949 0 0 0-.225.027c-.03 0-.061.011-.092.014a.465.465 0 0 1-.08-.258.426.426 0 0 1 .276-.408z",
    transform: "rotate(14.98 -55.666 397.553)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10756"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7179",
    d: "M345.585 529.71h.017a.88.88 0 0 0 1-.871 1.9 1.9 0 0 1-.008-.343c0-.017.01-.06.014-.075a1.82 1.82 0 0 1 .066-.218 1.4 1.4 0 0 1 .357-.459.633.633 0 0 0 .05-.835.618.618 0 0 0-.467-.241 1.321 1.321 0 0 0-.362-.4c-.748-.557-1.86-.079-2.545.352a2.986 2.986 0 0 0-1.723 2.634 1.783 1.783 0 0 0 3.027 1.254 2.255 2.255 0 0 0 .574-.798z",
    transform: "translate(-258.379 -437.962)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7210",
    d: "M346.683 522.912a.529.529 0 0 0-.057-.749c-.864-.737-1.72-1.516-2.547-2.269l-.779-.707a.529.529 0 0 0-.787.087q-.4.571-.81 1.138c-.676.946-1.374 1.924-2.036 2.917a.53.53 0 0 0 .134.725q.711.5 1.421 1.012.885.632 1.778 1.265a.529.529 0 0 0 .712-.094c.533-.643 1.112-1.273 1.671-1.882.432-.469.876-.955 1.3-1.443zm-3.467 2.275q-.692-.491-1.378-.982l-1-.715c.566-.835 1.156-1.661 1.73-2.463l.467-.655.335.3c.7.641 1.429 1.3 2.167 1.942-.307.345-.621.687-.928 1.02-.463.507-.937 1.022-1.393 1.553z",
    transform: "translate(-256.828 -433.45)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10767"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9739",
    d: "M0 .662a17.332 17.332 0 0 0 .153 2.476A.654.654 0 0 0 .8 3.7a.68.68 0 0 0 .093-.007.654.654 0 0 0 .555-.74 16.092 16.092 0 0 1-.14-2.291c0-.22 0-.441.008-.662Q.664.044.007.1C0 .288 0 .475 0 .662z",
    transform: "rotate(45 -38.995 151.391)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9740",
    d: "M.607 0A.654.654 0 0 0 0 .7c.03.414.044.863.044 1.374 0 .549-.017 1.1-.034 1.652q.656-.056 1.311-.1c.016-.519.03-1.037.03-1.553 0-.542-.016-1.021-.048-1.467A.65.65 0 0 0 .607 0z",
    transform: "rotate(45 -33.045 153.894)",
    style: {
      fill: "#525d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9741",
    d: "M2.049.31C1.559.354 1.075.4.6.438a.654.654 0 0 0 .053 1.306h.055c.478-.04.966-.084 1.46-.129.421-.038.846-.077 1.271-.113s.874-.071 1.309-.1c.787-.053 1.566-.09 2.317-.09a.654.654 0 1 0 0-1.312c-.746 0-1.512.035-2.282.085q-.655.043-1.311.1c-.477.039-.953.081-1.423.125z",
    transform: "rotate(45 -35.591 147.948)",
    style: {
      fill: "#525d7d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10961",
    d: "M1.157 2.057.579 3.739 0 5.422m7.244-3.663 1.892 5.008M12.278 0l3.432 1.883",
    transform: "rotate(-177 34.121 10.076)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10962",
    d: "M-3176.509 5157.963s.042-1.993 0-3.667 2-2.607 2.918-2.607h5.571a1.53 1.53 0 0 1 1.288.525c.465.612 2.906 3.182 2.906 3.182h8.961",
    transform: "translate(3193.081 -5074.948)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10963",
    d: "M836.39 723.167c.869-1.937.9-1.613-1.226-2.331-2.647-.893-1.95 0-6.449 0h-11.549s-6.166-.836-6.982.864-2.675 6.393-4.073 7.857c-3.793 2.178 2.412 4.534 4.719 2.12 2.306-.185 7.3.052 8.475 0 3.563-.156 7.419.206 10.979 0 2.493-.147 4.973-5.985 6.106-8.51z",
    transform: "translate(-780.974 -627.993)",
    style: {
      fill: "#93cbe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10964",
    d: "M-3148.385 5172.855h-10.46a3.822 3.822 0 0 0-3.2 2.068c-.691 1.01-5.8 10.591-5.8 10.591",
    transform: "translate(3188.674 -5082.044)",
    style: {
      strokeWidth: "2.2px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10965",
    d: "M-3176.509 5161.353v15.4a2.47 2.47 0 0 0 2.646 2.312h28.413c1.932 0 3.005-1.241 4.092-2.719a47.883 47.883 0 0 0 4.21-8.344c.285-1.241-1.006-2.11-2.57-2.1s-9.971 0-9.971 0",
    transform: "translate(3193.081 -5075.091)",
    style: {
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10966",
    d: "M-3631.306 5580.469v3.658",
    transform: "translate(3680.457 -5496.793)",
    style: {
      strokeWidth: "2.2px",
      strokeLinecap: "round",
      stroke: "#525d7d",
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptyData);
export default __webpack_public_path__ + "static/media/img_empty_data.6fc933f42879f7c1e99f98181567cb0a.svg";
export { ForwardRef as ReactComponent };